module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/181-trinidad-and-tobago-43711fb04124a75319c1b308e0c14338.svg";